export default "__VITE_PUBLIC_ASSET__12299002__"